module.exports = __webpack_public_path__ + "img/体系构建select.bbf41960.svg";